import BaseIcon from './BaseIcon';
import React = require('react');

export default class ExpandMoreIcon extends BaseIcon {
    protected renderIcon(): React.ReactNode {
        return <span className="material-icons">expand_more</span>;
    }
}
